import { useState } from 'react'
import ConfirmOrRejectModal from 'src/features/base/components/ConfirmOrRejectModal'
import Modal from 'src/components/Modal'
import UnlinkPageWithBadge from '../../../UnlinkPageWithBadge/UnlinkPageWithBadge'
import { UnlinkOrigin } from '../../../../RestockingTypes'
import * as S from './ExitActionsModal.styles'

interface ExitActionsModalProps {
  show: boolean
  title: string
  dataTestId: string
  idPage: number | undefined
  onClose: () => any
  onSuccess: () => void
  logoffAction: () => void
  setShowExitActionsModal: React.Dispatch<React.SetStateAction<boolean>>
}

const ExitActionsModal: React.FC<ExitActionsModalProps> = ({
  show,
  title,
  dataTestId,
  idPage,
  onClose,
  setShowExitActionsModal,
  logoffAction,
  onSuccess,
}) => {
  const [showLogoffConfirmModal, setShowLogoffConfirmModal] = useState(false)
  const [showUnlinkFlow, setShowUnlinkFlow] = useState(false)

  const closeLogoffConfirmModal = () => {
    setShowLogoffConfirmModal(false)
    setShowExitActionsModal(true)
  }

  const setLogoffAction = () => {
    setShowExitActionsModal(false)
    setShowLogoffConfirmModal(true)
  }

  const cancelAction = () => setShowExitActionsModal(false)

  const setInterruptRestockingAction = () => {
    setShowExitActionsModal(false)
    setShowUnlinkFlow(true)
  }

  const reopenExitActionsModal = () => setShowExitActionsModal(true)

  return (
    <>
      <Modal
        show={show}
        testId={dataTestId}
        centered
        title={title}
        closeButtonAction={onClose}
        closedButton
        body={(
          <S.Container>
            <S.CustomButton
              title='Sair e continuar vinculado'
              bgColor='confirm'
              hoverColor='confirmHover'
              letterColor='white'
              data-testid='logoff-button-test-id'
              onClick={setLogoffAction}
            />
            <S.CustomButton
              title='Me desvincular da página'
              bgColor='cancel'
              hoverColor='cancelHover'
              letterColor='white'
              data-testid='interrupt-restocking-button-test-id'
              onClick={setInterruptRestockingAction}
            />
            <S.CustomButton
              title='Cancelar'
              bgColor='darkBlue'
              hoverColor='darkBlueHover'
              letterColor='white'
              data-testid='cancel-button-test-id'
              onClick={cancelAction}
            />
          </S.Container>
        )}
      />
      <UnlinkPageWithBadge
        idPage={idPage}
        origin={UnlinkOrigin.WEBAPP_PAUSE}
        confirmTitle='Me desvincular da página'
        confirmDataTestId='confirm-exit-actions-modal-test-id'
        open={showUnlinkFlow}
        onOpenChange={setShowUnlinkFlow}
        onSuccess={onSuccess}
        onCancel={reopenExitActionsModal}
      />
      <ConfirmOrRejectModal
        show={showLogoffConfirmModal}
        title='Sair e continuar vinculado'
        description={'Você continua como keeper desta página e ninguém mais poderá assumir a reposição. '
          + 'Para liberar o serviço, use "Me desvincular da página".'}
        confirmButtonText='Sair'
        rejectButtonText='Voltar'
        onConfirm={logoffAction}
        onReject={closeLogoffConfirmModal}
        onClose={closeLogoffConfirmModal}
        dataTestId='confirm-logoff-exit-actions-modal-test-id'
      />
    </>

  )
}

export default ExitActionsModal
